import { render } from "./StoreCardInfo.vue?vue&type=template&id=532c785b&scoped=true"
import script from "./StoreCardInfo.vue?vue&type=script&lang=js"
export * from "./StoreCardInfo.vue?vue&type=script&lang=js"

import "./StoreCardInfo.vue?vue&type=style&index=0&id=532c785b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-532c785b"

export default script